<template>
  <WmsAgreementModal
    ref="agreementModalRef"
    :contract-content="modalData.contractContent"
    :redirect-href="modalData.redirectHref"
    @cancel="handleCancel"
    @accepted="handleAccepted"
  />
  <WmsAgreementCancelModal
    ref="cancelModalRef"
    @back="handleBack"
    @confirm="handleConfirmCancel"
  />
</template>

<script setup>
import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import WmsAgreementModal from './WmsAgreementModal';
import WmsAgreementCancelModal from './WmsAgreementCancelModal';

const store = useStore();
const agreementModalRef = ref(null);
const cancelModalRef = ref(null);

const modalData = ref({
  open: false,
  contractContent: null,
  redirectHref: '/supplies-management',
});

const resetModalData = () => {
  modalData.value = {
    open: false,
    contractContent: null,
    redirectHref: '/supplies-management',
  };
  store.commit('navigation/SET_WMS_AGREEMENT_MODAL_DATA', modalData.value);
};

const showAgreementDeclinedToaster = () => {
  store.commit('common/SET_TOASTER_DATA', {
    type: 'info',
    title: '',
    description: 'Sözleşmeyi onaylamadınız.',
  });
};

const showAgreementApprovedToaster = () => {
  store.commit('common/SET_TOASTER_DATA', {
    type: 'success',
    title: '',
    description: 'Sözleşmeyi onayladınız.',
  });
};

const APPROVED_TOAST_REDIRECT_DELAY_MS = 3000;

watch(
  () => store.getters['navigation/getWmsAgreementModalData'],
  (data) => {
    if (!data?.open) return;
    modalData.value = { ...data };
    agreementModalRef.value?.openModal();
  },
  { deep: true },
);

const handleCancel = () => {
  agreementModalRef.value?.hideForCancel();
  cancelModalRef.value?.openModal();
};

const handleBack = () => {
  agreementModalRef.value?.openModal();
};

const handleConfirmCancel = () => {
  resetModalData();
  showAgreementDeclinedToaster();
};

const handleAccepted = async (redirectHref) => {
  const href = redirectHref || '/supplies-management';
  resetModalData();
  showAgreementApprovedToaster();
  await new Promise((resolve) => {
    setTimeout(resolve, APPROVED_TOAST_REDIRECT_DELAY_MS);
  });
  window.location.href = href;
};
</script>
